module.exports = __webpack_public_path__ + "img/oauth-twitter.e531baae.svg";